import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';
import User from '_class/User';
import Moment from 'moment';
import { Spinner } from 'UI';
import { PhoneInput } from 'UI/Inputs';
import { Flex, Button, Icon, TooltipMenu } from '@haldor/ui';
import './_studentDetailsForm.scss';

var StudentDetailsForm = /*#__PURE__*/function (_Component) {
  _inherits(StudentDetailsForm, _Component);

  var _super = _createSuper(StudentDetailsForm);

  function StudentDetailsForm(props) {
    var _this;

    _classCallCheck(this, StudentDetailsForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.setState({
        currentGuadians: _toConsumableArray(_this.props.guardians)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      values.guardians = _this.state.currentGuadians;
      values.authoritative = _this.state.currentStudent.authoritative;

      if (values.mobilePhone != null && values.mobilePhone != '') {
        values.mobilePhone = '+' + values.mobilePhone;
        values.mobilePhone = parsePhoneNumber(values.mobilePhone).format('E.164');
      }

      _this.setState({
        loading: true
      });

      _this.props.onModalSave(values);
    });

    _defineProperty(_assertThisInitialized(_this), "onCancel", function () {
      _this.props.cancelModal();
    });

    _defineProperty(_assertThisInitialized(_this), "changeStudentPermissionLevel", function (status) {
      var currentStudent = _this.state.currentStudent;
      currentStudent.authoritative = status;

      _this.setState({
        currentStudent: currentStudent
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onGuardianStatusChange", function (guardianId, status) {
      var guardians = _this.state.currentGuadians;
      var guardianIndex = guardians.findIndex(function (g) {
        return g.id == guardianId;
      });
      guardians[guardianIndex].active = status;

      _this.setState({
        currentGuadians: guardians
      });
    });

    _defineProperty(_assertThisInitialized(_this), "validatePhone", function (value) {
      if (value == null || value == '') {
        return undefined;
      }

      if (value.length < 5) {
        return _this.props.translate('Enter a valid phone number');
      }

      var number = '+' + value;

      if (isValidPhoneNumber(number)) {
        return undefined;
      }

      return _this.props.translate('Enter a valid phone number');
    });

    _defineProperty(_assertThisInitialized(_this), "validatePID", function (value) {
      if (value != null && value != '') {
        var dateOfBirth = "";
        var length = value.toString().length;
        /** en-us validering **/

        if (length > 6 && (value.toString().charAt(6) == "-" || value.toString().charAt(6) == "A")) {
          dateOfBirth = value.toString().substring(0, 6);

          if (value.toString().charAt(6) == "-") {
            dateOfBirth = dateOfBirth.slice(0, 4) + "19" + dateOfBirth.substring(4);
          } else {
            dateOfBirth = dateOfBirth.slice(0, 4) + "20" + dateOfBirth.substring(4);
          }

          if (Moment(dateOfBirth, "DDMMYYYY", true).isValid()) {
            return null;
          }
        }
        /** sv-se nb-no da-dk validering **/


        if (length > 7) {
          dateOfBirth = value.toString().substring(0, 8);
          /** sv-se validering **/

          if (Moment(dateOfBirth, "YYYYMMDD", true).isValid()) {
            return null;
          }
          /** nb-no da-dk validering **/


          if (Moment(dateOfBirth, "DDMMYYYY", true).isValid()) {
            return null;
          }
        }

        return _this.props.translate('pid-field-validation');
      }
    });

    _this.state = {
      currentStudent: _this.props.currentStudent,
      currentGuadians: [],
      loading: false
    };
    return _this;
  }

  _createClass(StudentDetailsForm, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          handleSubmit = _this$props.handleSubmit,
          submitting = _this$props.submitting,
          valid = _this$props.valid,
          initialValues = _this$props.initialValues;
      var country = this.props.tenant.lcid.slice(-2);
      var user = new User(this.props.currentUser);

      if (this.state.loading) {
        return /*#__PURE__*/React.createElement("div", {
          className: "userdetails edit-form"
        }, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "userdetails edit-form"
      }, /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit(this.submit),
        className: "form form-component"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('phone')), /*#__PURE__*/React.createElement(Field, {
        name: "mobilePhone",
        type: "text",
        component: PhoneInput,
        countryCode: country,
        validate: this.validatePhone
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('e-mail')), /*#__PURE__*/React.createElement(Field, {
        name: "email",
        type: "text",
        component: "input",
        disabled: true
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('street-address')), /*#__PURE__*/React.createElement(Field, {
        name: "street-address",
        type: "text",
        component: "input",
        disabled: true
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          "float": "left",
          width: "35%",
          paddingRight: "1.75em"
        }
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('zip-code')), /*#__PURE__*/React.createElement(Field, {
        name: "zip-code",
        type: "text",
        component: "input",
        disabled: true
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          "float": "left",
          width: "65%"
        }
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('address')), /*#__PURE__*/React.createElement(Field, {
        name: "address",
        type: "text",
        component: "input",
        disabled: true
      })), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('pid')), /*#__PURE__*/React.createElement(Field, {
        name: "pid",
        type: "text",
        component: "input",
        placeholder: this.props.translate('date-format'),
        validate: this.validatePID
      })), user.isAdministrator() ? /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('permissions-as-guardian')), /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement("label", {
        style: {
          marginTop: "0px",
          width: "80%"
        }
      }, this.props.currentStudent.firstName + " " + this.props.currentStudent.lastName + " (" + this.props.translate('student') + ")"), /*#__PURE__*/React.createElement("div", {
        className: "studentPermissionsTooltip"
      }, /*#__PURE__*/React.createElement(TooltipMenu, {
        trigger: this.state.currentStudent.authoritative ? /*#__PURE__*/React.createElement("div", null, this.props.translate('active'), /*#__PURE__*/React.createElement(Icon, {
          name: "Chevron"
        })) : /*#__PURE__*/React.createElement("div", null, this.props.translate('inactive'), /*#__PURE__*/React.createElement(Icon, {
          name: "Chevron"
        })),
        id: "studentPermissionsTooltip"
      }, /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: function onClick(e) {
          e.preventDefault();

          _this2.changeStudentPermissionLevel(!initialValues.authoritative);
        }
      }, this.state.currentStudent.authoritative ? this.props.translate('inactive') : this.props.translate('active'))), /*#__PURE__*/React.createElement("span", {
        className: "tooltiptext"
      }, this.state.currentStudent.authoritative ? this.props.translate('permissions-authoritative-description') : this.props.translate('permissions-non-authoritative-description'))))) : null, user.isAdministrator() ? /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, this.state.currentGuadians.map(function (guardian) {
        return /*#__PURE__*/React.createElement(Flex, {
          key: "guardianDiv-" + guardian.id
        }, /*#__PURE__*/React.createElement("label", {
          style: {
            marginTop: "0px",
            width: "80%"
          }
        }, guardian.firstName + " " + (guardian.lastName != null ? guardian.lastName : null)), /*#__PURE__*/React.createElement(TooltipMenu, {
          trigger: guardian.active ? /*#__PURE__*/React.createElement("div", null, _this2.props.translate('active'), /*#__PURE__*/React.createElement(Icon, {
            name: "Chevron"
          })) : /*#__PURE__*/React.createElement("div", null, _this2.props.translate('inactive'), /*#__PURE__*/React.createElement(Icon, {
            name: "Chevron"
          })),
          id: "guardianPermissionsTooltip" + guardian.id
        }, /*#__PURE__*/React.createElement(TooltipMenu.Item, {
          onClick: function onClick(e) {
            e.preventDefault();

            _this2.onGuardianStatusChange(guardian.id, !guardian.active);
          }
        }, guardian.active ? _this2.props.translate('inactive') : _this2.props.translate('active'))));
      })) : null, /*#__PURE__*/React.createElement("div", {
        className: "form-row submit",
        style: {
          marginTop: '1.25rem',
          marginBottom: '1.25rem'
        }
      }, /*#__PURE__*/React.createElement(Button, {
        disabled: !valid || submitting
      }, this.props.translate('save')), /*#__PURE__*/React.createElement("div", {
        className: "align-right"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.onCancel
      }, this.props.translate('Cancel'))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }))));
    }
  }]);

  return StudentDetailsForm;
}(Component);

function mapStateToProps(state, ownProps) {
  return {
    initialValues: ownProps.currentStudent,
    guardians: state.user.guardians,
    languages: state.Languages.languages,
    translate: translate(state.Languages.translations),
    tenant: state.user.tenant,
    currentUser: state.user.currentUser
  };
}

export default connect(mapStateToProps)(reduxForm({
  form: 'StudentDetailForm',
  destroyOnUnmount: true
})(StudentDetailsForm));